import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';

import { QuestionnaireForm } from '../../../components/forms/questionnaireForm';
import { ContentContainer } from '../../../components/layout/contentContainer';
import { HeaderContainer } from '../../../components/layout/headerContainer';
import { QuestionnaireHeader } from '../../../components/questionnaire/header';
import { useSDK } from '../../index';

export const Questionnaire = observer((): ReactElement => {
	const rootStore = useSDK();
	return (
		<>
			<HeaderContainer>
				<QuestionnaireHeader>{rootStore.formsStore.chatQuestionnaireSheet?.header}</QuestionnaireHeader>
			</HeaderContainer>
			<ContentContainer>
				<QuestionnaireForm />
			</ContentContainer>
		</>
	);
});
